import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';
import type { HomeVisionContent } from '../../models/home-vision-content.model';
import { HomeVisionService } from '../../services/home-vision.service';
import { isExternalVisionUrl } from '../../utils/home-vision-banner.mapper';
import {
  parseParaMiInternalLink,
  routerLinkCommandsForInternal,
  type ParaMiInternalLink,
} from '../../utils/home-para-mi-link.util';
import {
  prepareVisionButtonHtml,
  prepareVisionTitleHtml,
  stripVisionHtml,
} from '../../utils/home-vision-html.util';

@Component({
  selector: 'app-home-cta-final',
  templateUrl: './home-cta-final.component.html',
  styleUrls: ['./home-cta-final.component.scss'],
  standalone: false,
})
export class HomeCtaFinalComponent implements OnInit {
  content: HomeVisionContent = buildInitialContent();
  titleSafe: SafeHtml = '';
  buttonLabelSafe: SafeHtml = '';
  buttonAriaLabel = '';

  constructor(
    private readonly homeVisionService: HomeVisionService,
    private readonly sanitizer: DomSanitizer
  ) {
    this.applyContent(this.content);
  }

  ngOnInit(): void {
    this.homeVisionService.loadContent().subscribe((content) => {
      this.content = content;
      this.applyContent(content);
    });
  }

  isExternalUrl(url: string): boolean {
    return isExternalVisionUrl(url);
  }

  /** Fragmento interno (#anchor); vacio si no aplica. */
  fragmentOf(url: string): string | undefined {
    const trimmed = (url ?? '').trim();
    if (trimmed.startsWith('#')) {
      return trimmed.slice(1);
    }
    return undefined;
  }

  /** Deep-link interno segun urlForward de BX (query + fragmento). */
  internalLinkOf(url: string): ParaMiInternalLink | null {
    return parseParaMiInternalLink(url);
  }

  /** /home → misma ruta; /login u otras → navega a esa pantalla. */
  routerCommandsOf(link: ParaMiInternalLink): string[] {
    return routerLinkCommandsForInternal(link);
  }

  private applyContent(content: HomeVisionContent): void {
    this.titleSafe = this.sanitizer.bypassSecurityTrustHtml(content.titleHtml); // NOSONAR
    const buttonHtml = prepareVisionButtonHtml(content.buttonLabel);
    this.buttonLabelSafe = this.sanitizer.bypassSecurityTrustHtml(buttonHtml); // NOSONAR
    this.buttonAriaLabel = stripVisionHtml(content.buttonLabel);
  }
}

function buildInitialContent(): HomeVisionContent {
  const mock = HOME_CONTENT_MOCK.ctaFinal;
  return {
    eyebrow: mock.eyebrow,
    titleHtml: prepareVisionTitleHtml(mock.title),
    descripcionEspecifica: mock.description,
    buttonLabel: prepareVisionButtonHtml(mock.buttonLabel),
    buttonUrl: mock.buttonUrl,
  };
}
